module.exports = __webpack_public_path__ + "d664201f/img/copy-icon.408fdb2d.svg";